@if (post(); as post) {
  <app-reading-progress-bar />

  <app-article-header [post]="post" />

  @if (hasContent()) {
    <!-- 3-column layout -->
    <div class="article-page__body">
      <app-article-toc
        [sections]="post.content!.sections"
        [activeSection]="activeSection()"
        [game]="post.game"
      />

      <main class="article-page__main">
        <app-article-body
          [content]="post.content!"
          [accentColor]="post.game.accentColor"
        />

        <app-article-author-card [post]="post" />

        <app-article-comments [slug]="post.slug" />
      </main>

      <app-article-sidebar [post]="post" />
    </div>

    <!-- Mobile sidebar content -->
    <div class="article-page__mobile-sidebar">
      <div class="article-page__mobile-categories">
        @for (cat of post.categories; track cat.id) {
          <a
            class="article-page__mobile-pill"
            [routerLink]="['/blog']"
            [queryParams]="{ category: cat.slug }"
          >{{ cat.name }}</a>
        }
      </div>

      @if (storeCategories().length > 0) {
        <div class="article-page__mobile-store-categories">
          @for (item of storeCategories(); track item.category.id) {
            <a
              class="article-page__mobile-store-pill"
              [routerLink]="item.link"
            >{{ item.category.name }}</a>
          }
        </div>
      }

      @if (relatedProducts().length > 0) {
        <div class="article-page__mobile-products">
          @for (item of relatedProducts(); track item.product.id) {
            <div class="article-page__mobile-product">
              <img
                [src]="item.product.imageUrl"
                [alt]="item.product.name"
                width="80"
                height="112"
                loading="lazy"
              />
              @if (item.link) {
                <a
                  class="article-page__mobile-product-name article-page__mobile-product-name--link"
                  [routerLink]="item.link"
                >{{ item.product.name }}</a>
              } @else {
                <span class="article-page__mobile-product-name">{{ item.product.name }}</span>
              }
              @if (item.showPrice) {
                <span
                  class="article-page__mobile-product-price"
                  [style.color]="post.game.accentColor"
                >{{ item.product.price | crc }}</span>
              } @else if (item.soldOut) {
                <span class="article-page__mobile-product-sold-out">{{ copy.productSoldOut }}</span>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Footer (tags + prev/next) -->
    <div class="article-page__section">
      <app-article-footer
        [post]="post"
        [prevPost]="prevPost()"
        [nextPost]="nextPost()"
      />
    </div>

    <!-- Related posts -->
    @if (relatedPosts().length > 0) {
      <section class="article-page__section article-page__related">
        <h2 class="article-page__section-title">{{ copy.relatedPostsTitle }}</h2>
        <div class="article-page__related-grid">
          @for (related of relatedPosts(); track related.id) {
            <app-blog-card [post]="related" />
          }
        </div>
      </section>
    }
  } @else {
    <!-- Coming soon state for articles without content -->
    <div class="article-page__coming-soon">
      <img
        class="article-page__mascot"
        src="/images/logo/writing.png"
        [alt]="copy.comingSoonMascotAlt"
        width="160"
        height="160"
        loading="lazy"
      />
      <h2 class="article-page__coming-soon-title">{{ copy.comingSoonTitle }}</h2>
      <p class="article-page__coming-soon-text">
        {{ copy.comingSoonText }}
      </p>
      <a class="article-page__coming-soon-btn" routerLink="/blog">{{ copy.backToBlog }}</a>
    </div>
  }
} @else if (loadError()) {
  <!-- B123: la API no respondió. Mascota de error (la del 404 solo para «no
       encontrado»); width/height intrínsecos, sin CLS. -->
  <div class="article-page__not-found article-page__load-error" role="alert">
    <img
      class="article-page__mascot"
      src="/images/logo/charging_error.png"
      [alt]="copy.errorMascotAlt"
      width="640"
      height="626"
      loading="lazy"
    />
    <h2 class="article-page__not-found-title">{{ copy.articleLoadError }}</h2>
    <button type="button" class="article-page__not-found-btn cursor-pointer" (click)="retry()">
      {{ copy.retry }}
    </button>
  </div>
} @else {
  <!-- 404 state -->
  <div class="article-page__not-found">
    <img
      class="article-page__mascot"
      src="/images/logo/404.png"
      [alt]="copy.notFoundMascotAlt"
      width="160"
      height="160"
      loading="lazy"
    />
    <h2 class="article-page__not-found-title">{{ copy.notFoundTitle }}</h2>
    <p class="article-page__not-found-text">
      {{ copy.notFoundText }}
    </p>
    <a class="article-page__not-found-btn" routerLink="/blog">{{ copy.backToBlog }}</a>
  </div>
}
